<template>
  <!-- 资讯页面复制而来 -->
  <el-dialog class="dialog-create-plan" :title="pageType==='add' ?'印记':'编辑印记'" :visible.sync="dialogVisible"
    :before-close="handleBeforeClose" width="800px">
    <div class="wrap">
      <div class="map_box">
        <div id="map"></div>
        
        <a class="btn-draw hairlines" @click="draw"></a>
      </div>

      <!-- <div class="btns">
        <button class="draw" @click="draw()">绘制</button>
        <button class="disDraw" @click="disDraw()">关闭绘制</button>
      </div> -->
      <!-- <p class="btn" @click="save">保存</p> -->
    </div>

    <div slot="footer" class="footer mt-30" v-if="pageType!=='detail'">
      <el-button @click="save" type="primary" :loading="loadingSave">确定</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import 'leaflet.pm'
import 'leaflet.pm/dist/leaflet.pm.css'


import { validate } from '@/utils/util'
import cmpUploadProgress from '@cmp/my-upload/upload-progress' // 上传组件
import cmpCkeditor from '@cmp/editor/ckeditor'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  components: {
    cmpUploadProgress,
    cmpCkeditor
  },
  data() {
    // let validateReceiptNumber = (rule, value, callback) => {
    //   if (!validate(value, 'numDecimal')) {
    //     return callback(new Error('最多支持两位小数'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      map: "",
      areaArr: [],
      drawRadius: '',
      isDrawing: false,



      loadingSave: false,
      pageType: 'add', // 页面类型 add 新增  edit 编辑  detail 详情
      detailId: '', // 用户id
      form: {},
      typeList: [],
      dialogVisible: false,
      configData: {
        tableName: 'collect'
      },
      imgUrl: '',
      rules: {
        scope: [
          { required: true, message: '必填', trigger: 'blur' },
          // { min: 1, max: 30, message: '请输入1到30个字符', trigger: 'blur' }
        ],
        title: [{ required: true, message: '必填', trigger: 'blur' }],
      },
      scopeList: [],
      
    }
  },
  methods: {
    init(type, id) {
      this.dialogVisible = true
      // // 清空弹框数据
      // this.form = {}
      // this.pageType = type // 页面类型
      // this.detailId = id || '' // 详情id
      // // 新增或编辑
      // if (this.detailId) {
      //   this.getDetailData()
      // }
      this.$nextTick(() => {
        // this.$refs.myCkeditor.initEditor()
        // this.$refs['form'].clearValidate() // 清空验证状态

        this.initMap2()
      })
    },

    initMap2() {
      // 图片的像素大小
      const imageWidth = 16206;
      const imageHeight = 10078;
      // 瓦片大小
      const tileSize = 256;

      // 计算最大级别
      const maxZoom = Math.ceil(Math.log2(Math.max(imageWidth, imageHeight) / tileSize));

      // 初始化地图
      this.map = L.map('map', {
        maxZoom: maxZoom, // 设置最大缩放级别
        minZoom: 2,       // 设置最小缩放级别
        crs: L.CRS.Simple, // 使用简单坐标系（非地理坐标系）
        attributionControl: false // 移除右下角leaflet标识
      });

      // 设置地图的初始视图
      const initialCenter = [imageHeight / 2, imageWidth / 2]; // 图片中心点
      const initialZoom = 0; // 初始缩放级别
      this.map.setView(initialCenter, initialZoom);

      // 添加自定义瓦片图层
      L.tileLayer('http://download.dev.tj720.com/tmp/leaflet/tiles/{z}/{x}/{y}.png', {
          tileSize: tileSize,   // 瓦片大小
          noWrap: true,         // 防止瓦片重复
          attribution: 'Custom Tiles', // 自定义属性
      }).addTo(this.map);

      // 设置地图的最大边界
      const southWest = this.map.unproject([0, imageHeight], maxZoom); // 左下角坐标
      const northEast = this.map.unproject([imageWidth, 0], maxZoom);  // 右上角坐标
      // const southWest = this.map.unproject([-1000, imageHeight+1000], maxZoom); // 左下角坐标
      // const northEast = this.map.unproject([imageWidth+1000, 0-1000], maxZoom);  // 右上角坐标
      const bounds = L.latLngBounds(southWest, northEast);
      this.map.setMaxBounds(bounds); // 限制地图拖动范围

      this.map.pm.setLang('zh')
      this.map.pm.addControls({
        position: "topleft",
        drawPolygon: false, // 添加绘制多边形
        drawMarker: false, //添加按钮以绘制标记
        drawCircleMarker: false, //添加按钮以绘制圆形标记
        drawPolyline: false, //添加按钮绘制线条
        drawRectangle:	true,	//添加按钮绘制矩形
        drawCircle: false, //  添加按钮绘制圆圈
        editMode: true, //  添加按钮编辑多边形
        dragMode: true, //   添加按钮拖动多边形
        cutPolygon: false, // 添加一个按钮以删除图层里面的部分内容
        removalMode: true  // 清除图层
      })

      this.getlatLngs()
    },
    getlatLngs() {
      // 设置全局路径样式
      // this.map.on('pm:loaded', ()=> {
      //   this.map.pm.setPathOptions({
      //     color: 'orange',
      //     fillColor: 'yellow',
      //     fillOpacity: 0.4
      //   })
      // });
      // this.map.on('pm:loaded', function() {
      //   this.map.pm.setPathOptions({
      //     color: 'orange',
      //     fillColor: 'yellow',
      //     fillOpacity: 0.4
      //   })
      // });
      //pm:drawstart 开始第一个点的时候调用
      //pm:drawend  禁止绘制时调用
      //pm:create  创建完成时调用
      this.map.on("pm:drawstart", e => {
        console.log(e, "first");

        // if(!this.isDrawing) {
        //   this.map.pm.enableDraw('Rectangle', {
        //     pathOptions: {
        //       color: 'pink',
        //       fillColor: 'skyblue',
        //       fillOpacity: 0.4
        //     }
        //   })
        //   this.isDrawing = true
        // }
      });
      this.map.on("pm:drawend", e => {
        console.log(e, "禁止绘制");
      });
      this.map.on("pm:create", e => {
        console.log(e, "绘制完成时调用");
        console.log(e.layer._latlngs[0], "绘制坐标")
        this.areaArr.push(e.layer._latlngs[0])
      });
    },
    draw() {
      this.map.pm.enableDraw("Rectangle", { 
        snappable: true,
        pathOptions: {
          color: '#EE443F',
          weight: 3,
          fillColor: '#fff',
          fillOpacity: 0.2
        }
      });

      // L.polygon(arr, { color: "#EE443F", weight: 3, fillColor: '#fff', fillOpacity: 0.2 }).addTo(this.map);
      //   this.map.pm.enableDraw("Marker", { snappable: false });
      //   this.map.pm.enableDraw("CircleMarker", { snappable: false });
    },
    // 关闭绘制
    disDraw() {
      this.map.pm.disableDraw("Rectangle");
      //    this.map.pm.disableDraw('Marker');
      //    this.map.pm.disableDraw('CircleMarker');
    },
    save() {
      console.log(this.areaArr)

      // this.drawObj = L.polygon(this.areaArr, { color: "#fff", fillColor: '#fff', fillOpacity: 0.1 }).addTo(this.map);
      this.drawObj = L.polygon(this.areaArr, { color: "#EE443F", weight: 3, fillColor: '#fff', fillOpacity: 0.2 }).addTo(this.map);
      // this.drawObj.bindTooltip('this is 个多边形');  //鼠标移上去的提示

      // color：线段颜色
      // weight：线段宽度
      // opacity：线段透明度
      // dashArray：虚线间隔
      // fill：是否填充内部(true/false)
      // fillColor:内部填充颜色，如不设置，默认为color颜色
      // fillOpacity：内部填充透明度
      // 画个圈
    //   this.drawRadius = L.circle([40.0224690112063, 116.51339229202272], {
    //     radius: 200
    //   }).addTo(this.map);
    },

    // 保存
    fromSubmit(form) {
      let content = this.$refs.myCkeditor.getContent() // 调用子组件方法
      if (!content) {
        this.$message.warning('请输入内容')
        return
      }
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .post('/bsInformationWeb/save', {
              ...this.form,
              content: content
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'edit') {
                  this.$message.success('资讯编辑成功')
                } else if (this.pageType === 'add') {
                  this.$message.success('资讯创建成功')
                }
                this.cancel()
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },



    

    // 获取详情
    getDetailData() {
      this.$http
        .get('/bsInformationWeb/find', {
          informationId: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.form = res.result
            if (res.result.img) {
              this.imgUrl = res.result.imgUrl
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        if (this.pageType == 'edit') {
          this.form.imgUrl = res.result.attPath
        }
        this.form.img = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.form.fileIds = fileStr
    },


    

    // 取消
    cancel() {
      console.log(22222222222)
      // this.imgUrl = ""
      // this.$refs['form'].resetFields()
      this.map.remove()
      this.dialogVisible = false
    },
    
    handleBeforeClose(done) {
      this.map.remove()
      // this.imgUrl = ""
      // this.$refs['form'].resetFields()
      // this.$refs.myCkeditor.setContent('')  // 处理编辑时偶尔不能渲染出富文本数据
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-create-plan {
  .map_box {
    position: relative;
    .btn-draw.hairlines {
      display: inline-block;
      width: 32px;
      height: 32px;
      background: transparent;
      position: absolute;
      left: 10px;
      top: 85px;
      z-index: 2;
    }

    #map {
      width: 100%;
      height: 600px;
      // height: calc(100vh);
      z-index: 1;
    }
  }
  // .btn {
  //   position: absolute;
  //   z-index: 9;
  //   top: 10px;
  //   left: 200px;
  //   font-size: 20px;
  //   cursor: pointer;
  // }
  // .btns {
  //   position: absolute;
  //   z-index: 9;
  //   left: 10px;
  //   bottom: 200px;
  //   color: blue;
  //   font-size: 20px;
  //   cursor: pointer;
  // }

  /deep/ .map-pic {
    object-fit: contain;
  }
  // /deep/ .leaflet-interactive {
  //   fill: red;
  //   stroke: yellow;
  // }

  // /deep/ .el-form-item {
  //   &.avatar-uploader-form {
  //     display: flex;
  //     flex-direction: row;
  //     .el-form-item__content {
  //       margin-left: 0 !important;
  //       display: flex;
  //       flex: 1;
  //       .avatar-uploader {
  //         width: 50%;
  //         border: 1px dashed #8c939d;
  //         height: 150px;
  //         display: flex;
  //         flex-direction: column;
  //         justify-content: center;
  //         align-items: center;
  //         .el-upload {
  //           width: 100%;
  //           height: 150px;
  //           display: flex;
  //           flex-direction: column;
  //           justify-content: center;
  //           align-items: center;
  //         }
  //         .el-icon-plus {
  //           font-size: 20px;
  //         }

  //         .el-upload__text {
  //           line-height: 1;
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>